import { render, staticRenderFns } from "./ExOwnerShipPicker.vue?vue&type=template&id=0b7da712&scoped=true"
import script from "./ExOwnerShipPicker.vue?vue&type=script&lang=js"
export * from "./ExOwnerShipPicker.vue?vue&type=script&lang=js"
import style0 from "./ExOwnerShipPicker.vue?vue&type=style&index=0&id=0b7da712&prod&lang=css"
import style1 from "./ExOwnerShipPicker.vue?vue&type=style&index=1&id=0b7da712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7da712",
  null
  
)

export default component.exports